import { Checkbox, Field, MessageLinkTarget, NumericInput, RadioGroup, TimeInput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { FieldSet, ListFieldSection } from 'Components/Layout';
import { QestlabListDropdown } from 'Components/List';
import ListType from 'Components/List/QestlabListDropdown/ListType';
import { IWorksheetComponent, WorksheetEquipmentDropdown } from 'Components/Worksheets/Core';
import { Guid } from 'Lib/Guid';
import { useSelector } from 'react-redux';
import { ConeCheckBy } from '../..';

let PreparationSectionBase: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const dcpId = useSelector(createWorksheetSelector!('Preparation.DynamicConePenetrometer.Id')) as Guid;
  const caliperId = useSelector(createWorksheetSelector!('Preparation.Callipers.Id')) as Guid;
  const measureId = useSelector(createWorksheetSelector!('Preparation.Measure.Id')) as Guid;
  const canShowCallipers = useSelector(createWorksheetSelector!('Preparation.ConeCheckBy')) === ConeCheckBy.Callipers;

  return (
    <>
      <ListFieldSection>
        <Field input={<QestlabListDropdown />} name="Preparation.Weather" listType={ListType.Weather} maxLength={50} />

        <Field
          input={<WorksheetEquipmentDropdown />}
          equipmentType="dynamic-cone-penetrometer"
          name="Preparation.DynamicConePenetrometer"
          importModel={{ Id: dcpId }}
        />

        <Field
          input={<RadioGroup />}
          name="Preparation.ConeCheckBy"
          options={[
            { value: ConeCheckBy.GoNoGoGauge, label: 'Go/no-go gauge' },
            { value: ConeCheckBy.Callipers, label: 'Callipers' },
          ]}
        />
        <FieldSet>
          <MessageLinkTarget id={'cone-diameter-satisfactory'} />
          <Field input={<Checkbox />} name="Preparation.ConeDiameterSatisfactory" />
        </FieldSet>
      </ListFieldSection>
      {canShowCallipers && (
        <ListFieldSection>
          <Field
            input={<WorksheetEquipmentDropdown />}
            equipmentType="caliper"
            name="Preparation.Callipers"
            importModel={{ Id: caliperId }}
          />
        </ListFieldSection>
      )}

      <ListFieldSection>
        <Field
          input={<WorksheetEquipmentDropdown />}
          equipmentType="measure"
          name="Preparation.Measure"
          importModel={{ Id: measureId }}
        />
        <Field input={<TimeInput />} name="Preparation.TimeOfTest" />
        <Field input={<NumericInput />} label="Hole Depth" name="Preparation.StartDepth" />
        <Field input={<NumericInput />} name="Preparation.DcpOffset" />
        <Field input={<NumericInput />} name="Preparation.ZeroReading" />
      </ListFieldSection>
    </>
  );
};

const PreparationSection = withInjectedProps(PreparationSectionBase);
export { PreparationSection };
export default PreparationSection;
